

<template>
    <div>
        <h1 class="font-bold my-10">
            {{ $t('nav.userAgreement') }}
        </h1>
        <p v-html="policy">
            
        </p>
    </div>
</template>

<script>
import api from '@/api';

export default {
    name: 'policy',
    components: {
    },
    data(){
        return {
            loading: false,
            policy: []
        }
    },
    methods: {
        async getPolicy(){
            this.loading = true
            try{ 
                const response = await api.get('info/')
                this.policy = response.data['policy']
            }
            catch(e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    async created(){
        await this.getPolicy()
    }
}
</script>